/*
  VSB how it compares (sections/vsb-compare): the "Show all rows" button, for
  a table folded to its first rows. Set up once the section nears the screen
  (vsbWhenNear), or on first focus.
*/

if (!customElements.get('d-compare')) {
  customElements.define('d-compare', class extends HTMLElement {
    connectedCallback() {
      const init = () => {
        if (this.dataset.ready) return;
        this.dataset.ready = 'true';
        this.querySelector('.d-compare__more button')?.addEventListener('click', (e) => {
          this.removeAttribute('data-folded');
          e.currentTarget.parentElement.remove();
        });
      };
      this.addEventListener('focusin', init, { once: true });
      if (window.vsbWhenNear) window.vsbWhenNear(this, init); else init();
    }
  });
}
